/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const PreviewThicknessIcon = ({ color, thickness }) => {
  return (
    <svg
      viewBox="0 0 500 50"
      id="svgExample"
      style={{width:"100%", height: "auto"}}
    >
      <path
        id="svgPath"
        d="M10 25 Q 125 15, 240 25 T 470 25"
        stroke={color}
        strokeWidth={thickness}
        fill="transparent"
      ></path>
    </svg>
  )
}
